import React, { useEffect, useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "../../core/json/siderbar_data";
import HorizontalSidebar from "./horizontalSidebar";
import CollapsedSidebar from "./collapsedSidebar";
import { useSelector } from "react-redux";
import { getUrls } from '../../api/apiurls.js';
const Sidebar = () => {
  var tenantType = getUrls().tenantType;
  const tenantId = localStorage.getItem("tenantId") || null;
  const allowedTenantIds = ["n4Xc96g6qyNcrq5dD", "jNrhXAynhAbQkrj8Y","8wNWEtTEdgoywriNX"];
  const isAllowedTenant = allowedTenantIds.includes(tenantId);

  const language = useSelector((state) => state.language || "en");
  const translation = useSelector((state) => state.translation || "en");
  
  const permissions = useSelector(state => state.permissions) || [];
  const roleTitle = useSelector(state => state.roleTitle) || [];
  const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || [];
// const permissions = actualPermissions.filter(p => p.module !== "purchases");
// console.log("permissions");
// console.log( permissions);
  // Check if user has permission to view a specific module
  const hasPermission = (permissionKey) => {
    return roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === permissionKey && p.Permission.toLowerCase() === 'view');
  };

  useEffect(() => {
    console.log(language, translation)
  }, [language, translation])

  const Location = useLocation();

  console.log("Location.pathname", Location.pathname);

  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");

  const toggleSidebar = (title) => {
    if (title == subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem) => {
    if (subitem == subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };
  // Filter SidebarData based on tenantType
  // const filteredSidebarData = SidebarData.map((mainLabel) => {
  //   const filteredSubmenuItemsByPermission = mainLabel.submenuItems?.filter(item => hasPermission(item.key)) || [];
  //   // Check if the tenantType is "all", then exclude specific submenuItems
  //   if (tenantType === "all") {
  //     const filteredSubmenuItems = filteredSubmenuItemsByPermission.filter(item => 
  //       !["category", "sub_category", "brands", "variant_attributes"].includes(item.key)
  //     ) || [];
  //     return { ...mainLabel, submenuItems: filteredSubmenuItems };
  //   }

  //   return mainLabel;
  // });



  const filteredSidebarData = SidebarData.reduce((acc, mainLabel) => {
    if (tenantId === "n4Xc96g6qyNcrq5dD" && mainLabel.key === "social_media") {
      return acc;
    }

      if (isAllowedTenant && mainLabel.key === "Incoming Inventory") {
        return acc;
      }
      //product_bidding
      
    let filteredSubmenuItemsByPermission = mainLabel.submenuItems.filter(item => hasPermission(item.key));
    filteredSubmenuItemsByPermission = filteredSubmenuItemsByPermission.filter(item => {
      if ((item.key == "couriers" || item.key == "product_bidding") && isAllowedTenant) {
        return false; // Exclude product_bidding if tenantType is not "all"
      }
      if ((tenantId == "n4Xc96g6qyNcrq5dD" || tenantId == "8wNWEtTEdgoywriNX") && item.key === "whattsapp-messages") {
          return false;
        }
      return true; // Include other items
    });
    
    // Exclude specific submenuItems if tenantType is "all"
    const filteredSubmenuItems = tenantType === "all" 
      ? filteredSubmenuItemsByPermission.filter(item => 
          // !["category", "sub_category", "brands", "variant_attributes"].includes(item.key))
          !["category", "sub_category", "brands"].includes(item.key))
      : filteredSubmenuItemsByPermission;
  
    // Only include mainLabel if it has any valid submenuItems
    if (filteredSubmenuItems.length > 0) {
      acc.push({ ...mainLabel, submenuItems: filteredSubmenuItems });
    }
  
    return acc;
  }, []);

  return (
    <div>
      <div className="sidebar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
          
              <ul>
                {filteredSidebarData?.map((mainLabel, index) => (
                  <li className="submenu-open" key={index}>
                    <h6 className="submenu-hdr">{translation?.[language]?.[mainLabel?.key] || mainLabel?.label}</h6>

                    <ul>
                      {mainLabel?.submenuItems?.map((title, i) => {
                        let link_array = [];
                        title?.submenuItems?.map((link) => {
                          link_array?.push(link?.link);
                          if (link?.submenu) {
                            link?.submenuItems?.map((item) => {
                              link_array?.push(item?.link);
                            });
                          }
                          return link_array;
                        });
                        title.links = link_array;
                        return (
                          <>
                            <li className="submenu" key={i}>
                              <Link
                                to={title?.link}
                                onClick={() => toggleSidebar(title?.label)}
                                className={`${
                                  subOpen == title?.label ? "subdrop" : ""
                                } ${
                                  title?.links?.includes(Location.pathname)
                                    ? "active"
                                    : ""
                                }
                            `}
                              >
                                {/* <Grid /> */}
                                {title?.icon}
                                <span>{translation?.[language]?.[title?.key] || title?.label }</span>
                                <span
                                  className={title?.submenu ? "menu-arrow" : ""}
                                />
                              </Link>
                              <ul
                                style={{
                                  display:
                                    subOpen == title?.label ? "block" : "none",
                                }}
                              >
                                {title?.submenuItems?.map(
                                  (item, titleIndex) => (
                                    <li
                                      className="submenu submenu-two"
                                      key={titleIndex}
                                    >
                                      {/* {item.lebel} */}
                                      <Link
                                        to={item?.link}
                                        className={
                                          item?.submenuItems
                                            ?.map((link) => link?.link)
                                            .includes(Location.pathname) ||
                                          item?.link == Location.pathname
                                            ? "active"
                                            : ""
                                        }
                                        onClick={() => {
                                          toggleSubsidebar(item?.label);
                                        }}
                                      >
                                        {translation?.[language]?.[item?.key] || item?.key + item?.label}
                                        <span
                                          className={
                                            item?.submenu ? "menu-arrow" : ""
                                          }
                                        />
                                      </Link>
                                      <ul
                                        style={{
                                          display:
                                            subsidebar == item?.label
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        {item?.submenuItems?.map(
                                          (items, titleIndex) => (
                                            <li key={titleIndex}>
                                              {/* {item.lebel} */}
                                              <Link
                                                to={items?.link}
                                                className={`${
                                                  subsidebar == items?.label
                                                    ? "submenu-two subdrop"
                                                    : "submenu-two"
                                                } ${
                                                  items?.submenuItems
                                                    ?.map((link) => link.link)
                                                    .includes(
                                                      Location.pathname
                                                    ) ||
                                                  items?.link ==
                                                    Location.pathname
                                                    ? "active"
                                                    : ""
                                                }`}
                                              >
                                                {items?.label}
                                              </Link>
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    </li>
                                  )
                                )}
                              </ul>
                            </li>
                          </>
                        );
                      })}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
      <HorizontalSidebar />
      <CollapsedSidebar />
    </div>
  );
};

export default Sidebar;
